var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setLocal } from '../saga/actions/local';
import Features from '../crudInterface/features';
import { init } from './socket';
const useSocket = (type, callback, identifierData) => {
    const socket = useSelector((s) => s[Features.SOCKET]);
    const token = useSelector((s) => s[Features.TOKEN]);
    const dispatch = useDispatch();
    const [isInizialized, setIsInizialized] = useState(false);
    // initialize socket
    useEffect(() => {
        const setNewSocket = () => __awaiter(void 0, void 0, void 0, function* () {
            const newSocket = yield init(token);
            if (!newSocket)
                return;
            dispatch(setLocal(Features.SOCKET, newSocket));
        });
        if ((!socket || !(socket === null || socket === void 0 ? void 0 : socket.connected)) && !isInizialized) {
            setIsInizialized(true);
            setNewSocket();
        }
        else if (!!socket && !!(socket === null || socket === void 0 ? void 0 : socket.connected)) {
            socket.emit(`${type}_identify`, identifierData);
        }
        // attach listener if callback is provided
        if (socket && !!callback) {
            socket.on(type, callback);
        }
        return () => {
            // remove listener if callback is provided
            if (socket && !!callback) {
                socket.off(type, callback);
            }
        };
    }, [socket, token, dispatch, callback, type, identifierData, isInizialized]);
    // return emit function
    const send = (data) => {
        if (!socket)
            return;
        socket.emit(type, data);
    };
    return send;
};
export default useSocket;
